import { tefProviders } from "@/features/establishments/constants/tefModels.constant";

export const tefConfigurationProductsTableColumns = (slug?: string) => [
  { value: 'product_category', label: 'Serviços' },
  { value: 'product', label: 'Produto' },
  { value: 'code', label: `Código ${slug ? tefProviders[slug as keyof typeof tefProviders].label || '' : ''}` },
  { value: 'updated_at', label: 'Atualizado em' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
